export default {"src":"/_next/static/media/expand.305a2a53.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};